import {compose, createStore, applyMiddleware} from "redux";
import thunkMiddleware from 'redux-thunk';

import reducers from './reducers';


const initialState : any = {

};

let _store;

let enhancers = applyMiddleware(thunkMiddleware);

if((window as any).__REDUX_DEVTOOLS_EXTENSION__)
     enhancers = compose(enhancers, (window as any).__REDUX_DEVTOOLS_EXTENSION__());


_store = createStore(reducers, initialState, enhancers);

export const store = _store;

